import * as S from './styles'
import { useHero } from './useHero'
import { Text, Typewriter } from '@/components'

export type HeroLandingPageProps = {
  handleScrollToElement: () => void
}
export const HeroLandingPage: React.FC<HeroLandingPageProps> = ({
  handleScrollToElement,
}) => {
  const { fontSizes, heroData } = useHero()

  return (
    <S.HeroContainer>
      <Text size={fontSizes.title} color="primary" align="center">
        {heroData.firstTitle}
      </Text>
      <div className="words">
        <Text size={fontSizes.title} color="primary" align="center">
          {heroData.secondTitle}
        </Text>
        <Typewriter texts={heroData.typewriterWords} size={fontSizes.title} />
      </div>
      <S.ButtonHero onClick={handleScrollToElement}>
        {heroData.buttonText}
      </S.ButtonHero>
    </S.HeroContainer>
  )
}
